import { z } from 'zod';
import { estimatingProposalContentSchema } from './estimating-proposal-content.contract.js';
export const estimatingPortalProposalCapability = 'estimating.portal-proposal.v1';
export const estimatingPortalProposalScopeProviderId = 'estimating.server.portal-proposal-scope';
export const estimatingPortalProposalResourceType = 'estimating.proposal-package';
export const estimatingPortalProposalReadGrant = 'estimating.portal-proposals.read';
export const estimatingPortalProposalSelectGrant = 'estimating.portal-proposals.select';
export const estimatingPortalProposalSelectionRequirementSchema = z.strictObject({
    estimateId: z.string().uuid(),
    proposalEstimateVersionId: z.string().uuid(),
    currentEstimateVersionId: z.string().uuid(),
    expectedRevision: z.number().int().positive(),
});
export const estimatingPortalProposalResponseSchema = z.strictObject({
    contractVersion: z.literal(estimatingPortalProposalCapability),
    data: estimatingProposalContentSchema,
    requireSignedDocument: z.boolean(),
    selectionRequirements: z.array(estimatingPortalProposalSelectionRequirementSchema).max(3),
});
export const estimatingPortalProposalSelectCommandSchema = z.strictObject({
    commandId: z.string().uuid(),
    packageId: z.string().uuid(),
    estimateId: z.string().uuid(),
    proposalEstimateVersionId: z.string().uuid(),
    currentEstimateVersionId: z.string().uuid(),
    expectedRevision: z.number().int().positive(),
    expectedPresentationHash: z.string().regex(/^[a-f0-9]{64}$/),
    acceptedByName: z.string().trim().min(1).max(240),
    acceptedAt: z.string().datetime({ offset: true }),
    documentInstanceId: z.string().uuid().nullable().default(null),
});
export const estimatingPortalProposalSelectResponseSchema = z.strictObject({
    data: estimatingPortalProposalResponseSchema,
    command: z.strictObject({
        commandId: z.string().uuid(),
        idempotent: z.boolean(),
    }),
});
export const estimatingPortalProposalDeclineCommandSchema = z.strictObject({
    commandId: z.string().uuid(),
    packageId: z.string().uuid(),
    estimateId: z.string().uuid(),
    proposalEstimateVersionId: z.string().uuid(),
    currentEstimateVersionId: z.string().uuid(),
    expectedRevision: z.number().int().positive(),
    expectedPresentationHash: z.string().regex(/^[a-f0-9]{64}$/),
    declinedAt: z.string().datetime({ offset: true }),
});
export const estimatingPortalProposalDeclineResponseSchema = estimatingPortalProposalSelectResponseSchema;
//# sourceMappingURL=estimating-portal-proposal.contract.js.map